module.exports = __webpack_public_path__ + "a3d856acb44598f26a19e8890b5abbae.png";